/* Copyright 2013 - 2022 Waiterio LLC */
import { css } from '@emotion/react'

export default css`
  label: d-none;
  display: none !important;
`
